import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';
import {Pagination, PaginationParams} from '../model/pagination';
import {LocationDto} from '../model/continent';
import {cleaningParams} from '../functions/cleaningParams';

@Injectable({
  providedIn: 'root'
})
export class AdventuresService {
  constructor(private httpClient: HttpClient) {}

  getAdventureList(params: PaginationParams): Observable<Pagination<LocationDto>>  {
    const cleanParams = cleaningParams(params);
    return this.httpClient.get<Pagination<LocationDto>>(`${environment.apiUrl}/public/adventure`,
      { params: { ...cleanParams } });
  }

  getAdventure(id: number): Observable<LocationDto>  {
    return this.httpClient.get<LocationDto>(`${environment.apiUrl}/public/adventure/${id}`);
  }

  getAdventureByUrl(url: string): Observable<LocationDto>  {
    return this.httpClient.get<LocationDto>(`${environment.apiUrl}/public/adventure/by-url/${url}`);
  }

  moveUp(id: number): Observable<boolean>  {
    return this.httpClient.put<boolean>(`${environment.apiUrl}/adventure/move-up/${id}`, id);

  }

  moveDown(id: number): Observable<boolean> {
    return this.httpClient.put<boolean>(`${environment.apiUrl}/adventure/move-down/${id}`, id);
  }

  saveAdventurePhoto(id: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/adventure/file/${id}`, formData);
  }

  saveAdventureFooterPhoto(id: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/adventure/footer/file/${id}`, formData);
  }

  saveAdventureCarousel(idAdventure: number, idCarousel: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/adventure/file/${idAdventure}/${idCarousel}`, formData);
  }

  deleteAdventureCarousel(idAdventure: number, idCarousel: number) {
    return this.httpClient.delete(`${environment.apiUrl}/adventure/${idAdventure}/${idCarousel}`);
  }

  saveEventPhoto(idAdventure: number, eventId: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/adventure/file/${idAdventure}/${eventId}`, formData);
  }

  deleteEventAdventure(idAdventure: number, idEvent: number,) {
    return this.httpClient.delete(`${environment.apiUrl}/adventure/${idAdventure}/${idEvent}`);
  }

  saveAdventure(adventure: LocationDto): Observable<LocationDto> {
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/adventure`, adventure);
  }

  delete(id: number) {
    return this.httpClient.delete(`${environment.apiUrl}/adventure/${id}`);
  }
}
